import _ from 'underscore';

export const MAX_Y_AXIS_LABEL_LENGTH = 18;
export const MAX_Y_AXIS_LABEL_LENGTH_FS = 30;
export const MAX_Y_AXIS_LABEL_ELLIPSIS_POSITION = MAX_Y_AXIS_LABEL_LENGTH - 4;
export const MAX_Y_AXIS_LABEL_ELLIPSIS_POSITION_FS = MAX_Y_AXIS_LABEL_LENGTH_FS - 4;
export const Y_AXIS_TICK_WIDTH = 110;
export const Y_AXIS_TICK_WIDTH_FS = 200;

export const getAxisConfig = _.memoize((isFullScreen = false) => {
    const yAxisLabelLength = isFullScreen ? MAX_Y_AXIS_LABEL_LENGTH_FS : MAX_Y_AXIS_LABEL_LENGTH;
    const yAxisLabelPosition = isFullScreen
        ? MAX_Y_AXIS_LABEL_ELLIPSIS_POSITION_FS
        : MAX_Y_AXIS_LABEL_ELLIPSIS_POSITION;
    const yAxisTickWidth = isFullScreen ? Y_AXIS_TICK_WIDTH_FS : Y_AXIS_TICK_WIDTH;

    return {
        yAxisLabelLength,
        yAxisLabelPosition,
        yAxisTickWidth,
    };
});

export function getTickLabelFontStyles(isFullScreen = false) {
    return {
        letterSpacing: -0.2,
        fontSize: isFullScreen ? 13 : 12,
    };
}
